import { createReducer, on } from '@ngrx/store';

import { loadDotCmsConfigurableContentSuccess } from './dotcms-configurable-contents.action';

export interface DotCmsConfigurableContentsState {
  [key: string]: string;
}

const initialState: DotCmsConfigurableContentsState = {};

export const dotCmsConfigurableContentsReducer = createReducer(
  initialState,
  on(loadDotCmsConfigurableContentSuccess, (state, action) => ({
    ...state,
    [action.payload.contentKey]: action.payload.identifier,
  }))
);
